export default __webpack_public_path__ + "static/media/invite-collaborators.d5dc6dea.svg";